import Dropdown from 'sma.admin/components/dropdowns/dropdown';

const dropdownButtonTempl = require('sma.admin/components/dropdowns/partials/dropdown_button.mustache');
const dropdownAccordionTempl = require('sma.admin/components/dropdowns/partials/jump_to_accordion.mustache');

const JumpToDropdown = Dropdown.extend({
	// Builds a dropdown to scroll to a specific element. It expects consistently id'ed elements.
	// Pass in the 'prefix' of the id as the prefix, and a list of dicts contataining the id suffix
	// and name of the objects to jump to. ie: [{'name': 'Element 1', 'id': 1}, {'name': 'Element 2', 'id': 2}]
	// with a suffix of 'sma-js-element-' will create a dropdown that will jump to sma-js-element-2 when Element 2
	// is clicked
	events: {
		'click .sma-js-dropdown-expand': 'stopPropagation',
	},
	initialize(options) {
		this.noCaret = options.noCaret || false;
		this.type = options.type || 'button';
		this.btnclass = options.btnclass || 'btn-default';
		this.extraClass = options.extraClass || '';
		this.title = options.title;
		this.textStyleButton = options.textStyleButton || false;
		this.rightAligned = options.rightAligned || false;
		this.setElement(options.element);
		this.prefix = options.prefix;
		this.groupPrefix = options.groupPrefix || '';
		this.objects = options.objects;
		this.items = [];
		this.accordion = false;
		this.noItemsText = options.noItemsText || '';

		this.setItems();

		this.addActionData = options.addActionData || (() => ({}));

		this.render();
	},
	stopPropagation(e) {
		const elementId = $(e.currentTarget).attr('href');
		const target = $(this.el).find(elementId);
		if (target.hasClass('show')) {
			target.prev('.sma-js-dropdown-wrapper').find('i').removeClass('arrows-1_minimal-up');
			target.prev('.sma-js-dropdown-wrapper').find('i').addClass('arrows-1_minimal-down');
			target.collapse('hide');
		} else {
			target.prev('.sma-js-dropdown-wrapper').find('i').removeClass('arrows-1_minimal-down');
			target.prev('.sma-js-dropdown-wrapper').find('i').addClass('arrows-1_minimal-up');
			target.collapse('show');
		}

		e.preventDefault();
		e.stopPropagation(); // prevents the dropdown from being closed
	},
	setItems() {
		this.objects.forEach((object) => {
			if (object.items && object.items.length) {
				this.accordion = true;
				const parentItem = {
					text: object.name,
					href: `#${this.groupPrefix}${object.id}`,
					id: object.id,
					subItems: [],
				};

				object.items.forEach((item) => {
					const newItem = {
						text: item.name,
						href: `#${this.prefix}${item.id}`,
					};
					parentItem.subItems.push(newItem);
				});
				this.items.push(parentItem);
			} else {
				const newItem = {
					text: object.name,
					href: `#${this.prefix}${object.id}`,
					id: object.id,
					subItems: [{
						text: this.noItemsText || gettext('No items'),
						href: null,
					}],
				};
				this.items.push(newItem);
			}
		});
	},
	render() {
		this.$el.empty();

		let templ;
		if (this.accordion) {
			templ = dropdownAccordionTempl;
		} else {
			templ = dropdownButtonTempl;
		}

		this.$el.html(templ({
			title: this.title,
			btnclass: this.btnclass,
			noCaret: this.noCaret,
			items: this.items,
			textStyleButton: this.textStyleButton ? 'text-style-button' : '',
			type: this.type,
			extraClass: this.extraClass,
			extraItemClass: this.extraItemClass,
			rightAligned: this.rightAligned,
		}));

		this.setEvents();
	},
});

module.exports = JumpToDropdown;
